<template>
    <div>
        <rkm-row v-if="showLegend">
            <rkm-col>
                <rkm-alert color="warning">
                    <span>* Preenchimento obrigatório.</span>
                </rkm-alert>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <ValidationObserver
                    ref="observer"
                    v-slot="{ handleSubmit, reset }"
                    slim
                >
                    <b-form
                        @submit.prevent="validateOnSubmit ? onSubmit(handleSubmit) : null"
                        @reset.prevent="reset"
                    >
                        <slot />
                    </b-form>
                </ValidationObserver>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
import { BForm } from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate';

export default {
    components: { BForm, ValidationObserver },
    methods: {
        onSubmit(handleSubmit) {

            handleSubmit(() => this.$emit('success'))
                .then(() => this.scrollToFirstInvalidField())
        },
        async validate(callbackOnSuccess) {

            const valid = await this.$refs.observer.validate()

            if (valid) {

                if (typeof callbackOnSuccess === 'function') {

                    callbackOnSuccess()
                }
            }
            else {

                this.scrollToFirstInvalidField()
            }

            return valid
        },
        validateSilent() {

            return this.$refs.observer.validate({ silent: true })
        },
        scrollToFirstInvalidField() {

            const error = this.$el.querySelector('.is-invalid')

            if (error) {

                const element = error.querySelector('input, select')

                error.scrollIntoView({ behavior: 'smooth', block: 'center' })

                if (element) {

                    element.focus({ preventScroll: true })
                }
            }
        },
        resetValidator() {

            this.$refs.observer.reset()
        },
    },
    props: {
        validateOnSubmit: { type: Boolean, default: false },
        showLegend: { type: Boolean, default: false },
    }
}
</script>